/* TPW Parts – Asennusvaraus (asennusten ajanvaraus)
   Näytetään kaikilla tuotteilla, joilla on tunniste "asennusvaraus". Kaikki tuotteet jakavat saman kalenterin.
   - Aikaisin varattava päivä: 3 arkipäivän päähän tästä päivästä
   - Arkipäiviin ei lasketa la/su, Suomen pyhäpäiviä eikä suljettuja päiviä
   - Aloitusajat ma–pe puolen tunnin välein 10:00–16:30 (työ 1,5 h valmis viim. klo 18)
   - Jokainen varaus varaa 2 h: varaus klo 10 → seuraava vapaa aika klo 12 */
(function (root) {
  'use strict';

  var OPEN_MIN = 10 * 60, CLOSE_MIN = 18 * 60, STEP_MIN = 30;
  var WORK_MIN = 90;
  var BLOCK_MIN = 120;
  function toMin(hhmm) { var p = hhmm.split(':'); return (+p[0]) * 60 + (+p[1]); }
  function fromMin(m) { return (m < 600 ? '0' : '') + Math.floor(m / 60) + ':' + (m % 60 < 10 ? '0' : '') + (m % 60); }
  var SLOTS = [];
  for (var sm = OPEN_MIN; sm + WORK_MIN <= CLOSE_MIN; sm += STEP_MIN) SLOTS.push(fromMin(sm));
  var LEAD_WORKDAYS = 3;
  var HORIZON_DAYS = 60;
  var TZ = 'Europe/Helsinki';
  var WEEKDAYS = ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'];
  var MONTHS = ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu',
    'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'];

  function d(y, m, day) { return new Date(Date.UTC(y, m - 1, day, 12)); }
  function addDays(dt, n) { var r = new Date(dt.getTime()); r.setUTCDate(r.getUTCDate() + n); return r; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(dt) { return dt.getUTCFullYear() + '-' + pad(dt.getUTCMonth() + 1) + '-' + pad(dt.getUTCDate()); }
  function fromIso(s) { var p = s.split('-'); return d(+p[0], +p[1], +p[2]); }

  function todayHelsinki(now) {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(now || new Date());
    var get = function (t) { return +parts.find(function (p) { return p.type === t; }).value; };
    return d(get('year'), get('month'), get('day'));
  }

  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, dd = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - dd - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451), month = Math.floor((h + l - 7 * m + 114) / 31),
      day = ((h + l - 7 * m + 114) % 31) + 1;
    return d(y, month, day);
  }

  var holidayCache = {};
  function finnishHolidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easterSunday(y), list = {};
    var add = function (dt, name) { list[iso(dt)] = name; };
    add(d(y, 1, 1), 'Uudenvuodenpäivä');
    add(d(y, 1, 6), 'Loppiainen');
    add(addDays(e, -2), 'Pitkäperjantai');
    add(addDays(e, 1), '2. pääsiäispäivä');
    add(d(y, 5, 1), 'Vappu');
    add(addDays(e, 39), 'Helatorstai');
    for (var j = 19; j <= 25; j++) { var jd = d(y, 6, j); if (jd.getUTCDay() === 5) add(jd, 'Juhannusaatto'); }
    add(d(y, 12, 6), 'Itsenäisyyspäivä');
    add(d(y, 12, 24), 'Jouluaatto');
    add(d(y, 12, 25), 'Joulupäivä');
    add(d(y, 12, 26), 'Tapaninpäivä');
    holidayCache[y] = list;
    return list;
  }

  function isWorkday(dt, closed) {
    var wd = dt.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    var k = iso(dt);
    if (finnishHolidays(dt.getUTCFullYear())[k]) return false;
    if (closed && closed[k]) return false;
    return true;
  }

  function earliestDate(today, closed) {
    var dt = today, count = 0;
    while (count < LEAD_WORKDAYS) { dt = addDays(dt, 1); if (isWorkday(dt, closed)) count++; }
    return dt;
  }

  function availableDays(today, closed) {
    var first = earliestDate(today, closed), last = addDays(today, HORIZON_DAYS), out = [];
    for (var dt = first; dt <= last; dt = addDays(dt, 1)) if (isWorkday(dt, closed)) out.push(iso(dt));
    return out;
  }

  function bookedMinutes(dayIso, booked) {
    var out = [], prefix = dayIso + 'T';
    Object.keys(booked).forEach(function (k) { if (k.indexOf(prefix) === 0) out.push(toMin(k.slice(11, 16))); });
    return out;
  }
  function freeSlots(dayIso, booked) {
    var taken = bookedMinutes(dayIso, booked);
    return SLOTS.filter(function (s) {
      var m = toMin(s);
      return taken.every(function (t) { return Math.abs(m - t) >= BLOCK_MIN; });
    });
  }

  function normalizePlate(v) { return String(v || '').toUpperCase().replace(/\s+/g, '').trim(); }
  function validPlate(v) {
    var p = normalizePlate(v);
    return /^[A-ZÅÄÖ]{1,3}-?\d{1,3}$/.test(p) || /^[A-ZÅÄÖ0-9-]{2,10}$/.test(p);
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }
  function validPhone(v) { return /^\+?[0-9 ()-]{6,20}$/.test(String(v || '').trim()); }
  function humanDate(dayIso) {
    var dt = fromIso(dayIso);
    return WEEKDAYS[dt.getUTCDay()] + ' ' + dt.getUTCDate() + '.' + (dt.getUTCMonth() + 1) + '.' + dt.getUTCFullYear();
  }

  function readJson(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function adaptProductPage(box) {
    var atcWrap = document.querySelector('.atc-wrap');
    if (atcWrap && atcWrap.parentNode) atcWrap.parentNode.insertBefore(box, atcWrap);
    var stock = document.getElementById('ProductStock');
    if (stock) { stock.dataset.hideStock = 'true'; stock.querySelectorAll('.in-stock,.out-stock').forEach(function (n) { n.remove(); }); }
    ['DeliveryEstimate', 'StockByLocation'].forEach(function (id) { var n = document.getElementById(id); if (n) n.style.display = 'none'; });
    document.querySelectorAll('.qty-control, .atc-dynamic, .stock-delivery-estimate, .stock-locations').forEach(function (n) { n.style.display = 'none'; });
    var qty = document.getElementById('QtyInput'); if (qty) qty.value = 1;
    var btn = document.getElementById('AddToCartBtn');
    if (btn) {
      var label = btn.querySelector('.atc-btn-label');
      if (label) { label.className = 'av-btn-label'; label.textContent = 'Varaa aika ja siirry kassalle'; }
    }
    var sticky = document.getElementById('StickyAtc'); if (sticky) sticky.style.display = 'none';
  }

  function init() {
    var box = document.getElementById('Asennusvaraus');
    if (!box) return;
    adaptProductPage(box);

    var booked = {}, closed = {};
    readJson('AsennusvarausBooked', []).forEach(function (s) { if (s) booked[String(s).trim()] = true; });
    readJson('AsennusvarausClosed', []).forEach(function (s) { if (s) closed[String(s).trim()] = true; });

    var today = todayHelsinki();
    var days = availableDays(today, closed).filter(function (k) { return freeSlots(k, booked).length > 0; });
    var daySet = {}; days.forEach(function (k) { daySet[k] = true; });

    var calEl = box.querySelector('[data-cal]');
    var slotsEl = box.querySelector('[data-slots]');
    var summaryEl = box.querySelector('[data-summary]');
    var errorEl = box.querySelector('[data-error]');
    var state = { month: null, day: null, slot: null };

    var firstMonth = days.length ? fromIso(days[0]) : today;
    var lastMonth = days.length ? fromIso(days[days.length - 1]) : today;
    state.month = d(firstMonth.getUTCFullYear(), firstMonth.getUTCMonth() + 1, 1);

    function monthKey(dt) { return dt.getUTCFullYear() * 12 + dt.getUTCMonth(); }

    function renderCalendar() {
      var m = state.month, y = m.getUTCFullYear(), mo = m.getUTCMonth();
      var startOffset = (m.getUTCDay() + 6) % 7;
      var daysInMonth = new Date(Date.UTC(y, mo + 1, 0)).getUTCDate();
      var canPrev = monthKey(m) > monthKey(firstMonth), canNext = monthKey(m) < monthKey(lastMonth);
      var html = '<div class="av-cal-head">' +
        '<button type="button" class="av-nav" data-prev ' + (canPrev ? '' : 'disabled') + ' aria-label="Edellinen kuukausi">‹</button>' +
        '<span class="av-month">' + MONTHS[mo] + ' ' + y + '</span>' +
        '<button type="button" class="av-nav" data-next ' + (canNext ? '' : 'disabled') + ' aria-label="Seuraava kuukausi">›</button></div>' +
        '<div class="av-grid av-wd"><span>ma</span><span>ti</span><span>ke</span><span>to</span><span>pe</span><span>la</span><span>su</span></div>' +
        '<div class="av-grid">';
      for (var i = 0; i < startOffset; i++) html += '<span></span>';
      for (var dayN = 1; dayN <= daysInMonth; dayN++) {
        var k = iso(d(y, mo + 1, dayN)), ok = !!daySet[k];
        html += '<button type="button" class="av-day' + (ok ? '' : ' is-off') + (state.day === k ? ' is-selected' : '') +
          '" data-day="' + k + '" ' + (ok ? '' : 'disabled') + '>' + dayN + '</button>';
      }
      html += '</div>';
      if (!days.length) html += '<p class="av-note">Vapaita aikoja ei juuri nyt ole. Ota yhteyttä: asiakaspalvelu@tpwparts.com</p>';
      calEl.innerHTML = html;
    }

    function renderSlots() {
      if (!state.day) { slotsEl.innerHTML = '<p class="av-note">Valitse ensin päivä kalenterista.</p>'; return; }
      var free = freeSlots(state.day, booked);
      slotsEl.innerHTML = '<p class="av-slots-title">Vapaat aloitusajat ' + humanDate(state.day) + '</p><div class="av-slot-row">' +
        SLOTS.map(function (s) {
          var ok = free.indexOf(s) !== -1;
          return '<button type="button" class="av-slot' + (state.slot === s ? ' is-selected' : '') + '" data-slot="' + s + '" ' +
            (ok ? '' : 'disabled aria-label="' + s + ' varattu"') + '>' + s + '</button>';
        }).join('') + '</div>';
    }

    function renderSummary() {
      summaryEl.textContent = state.day && state.slot
        ? 'Valittu aika: ' + humanDate(state.day) + ' klo ' + state.slot + ' (asennus n. 1,5 h)'
        : '';
    }

    box.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || t.disabled || !box.contains(t)) return;
      if (t.hasAttribute('data-prev')) { state.month = d(state.month.getUTCFullYear(), state.month.getUTCMonth(), 1); renderCalendar(); }
      else if (t.hasAttribute('data-next')) { state.month = d(state.month.getUTCFullYear(), state.month.getUTCMonth() + 2, 1); renderCalendar(); }
      else if (t.dataset.day) { state.day = t.dataset.day; state.slot = null; renderCalendar(); renderSlots(); }
      else if (t.dataset.slot) { state.slot = t.dataset.slot; renderSlots(); }
      renderSummary();
      hideError();
    });

    function field(name) { return box.querySelector('[name="av_' + name + '"]'); }
    function val(name) { var f = field(name); return f ? f.value.trim() : ''; }
    function showError(msg, focusEl) {
      errorEl.textContent = msg; errorEl.hidden = false;
      if (focusEl && focusEl.focus) focusEl.focus();
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function hideError() { errorEl.hidden = true; }

    var plateEl = field('rekisteri');
    if (plateEl) plateEl.addEventListener('blur', function () { plateEl.value = normalizePlate(plateEl.value); });

    function validate() {
      if (!state.day || !state.slot) return showError('Valitse asennuspäivä ja kellonaika.', calEl), false;
      if (!val('etunimi')) return showError('Täytä etunimi.', field('etunimi')), false;
      if (!val('sukunimi')) return showError('Täytä sukunimi.', field('sukunimi')), false;
      if (!validPhone(val('puhelin'))) return showError('Tarkista puhelinnumero.', field('puhelin')), false;
      if (!validEmail(val('sahkoposti'))) return showError('Tarkista sähköpostiosoite.', field('sahkoposti')), false;
      if (!validPlate(val('rekisteri'))) return showError('Tarkista rekisterinumero (esim. ABC-123).', plateEl), false;
      if (!val('auto')) return showError('Kerro auton merkki ja malli.', field('auto')), false;
      var ok = field('ehdot');
      if (ok && !ok.checked) return showError('Hyväksy varausehdot jatkaaksesi.', ok), false;
      return true;
    }

    function properties() {
      return {
        'Asennusaika': humanDate(state.day) + ' klo ' + state.slot,
        'Nimi': val('etunimi') + ' ' + val('sukunimi'),
        'Puhelin': val('puhelin'),
        'Sähköposti': val('sahkoposti'),
        'Rekisterinumero': normalizePlate(val('rekisteri')),
        'Auto': val('auto'),
        'Lisätiedot': val('lisatiedot') || '-',
        '_varaus': state.day + 'T' + state.slot
      };
    }

    document.addEventListener('submit', async function (e) {
      var form = e.target;
      if (!form || !form.matches('[data-type="add-to-cart-form"]') || !document.getElementById('Asennusvaraus')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!validate()) return;

      var idEl = form.querySelector('[name="id"]');
      var variantId = idEl ? idEl.value : null;
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Varataan…'; }

      try {
        var cart = await (await fetch('/cart.js')).json();
        var updates = {};
        cart.items.forEach(function (it) { if (it.properties && it.properties._varaus) updates[it.key] = 0; });
        if (Object.keys(updates).length) {
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
        }
        var res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties() }] })
        });
        if (!res.ok) throw new Error(await res.text());
        window.location.href = '/checkout';
      } catch (err) {
        console.error('Asennusvaraus:', err);
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
        showError('Varauksen lisääminen epäonnistui. Yritä uudelleen tai ota yhteyttä asiakaspalveluun.');
      }
    }, true);

    renderCalendar();
    renderSlots();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(this);
